import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { INotification } from '../interfaces/INotification';
import { IUserNotification } from '../interfaces/IUserNotification';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private httpClient = inject(HttpClient);

    public getNotifications(cursor?: string | null): Observable<INotification> {
        return this.httpClient
            .get<INotification>(`${environment.apiUrl}/me/notifications${cursor ? `?cursor=${cursor}` : ''}`)
            .pipe(catchError((error: Error) => throwError(() => new Error(error.message))));
    }

    public getUserNotification(id: string): Observable<IUserNotification> {
        return this.httpClient
            .get<IUserNotification>(`${environment.apiUrl}/me/notifications/${id}`)
            .pipe(catchError((error: Error) => throwError(() => new Error(error.message))));
    }

    public markUserNotificationAsRead(id: string): Observable<IUserNotification> {
        return this.httpClient
            .post<IUserNotification>(`${environment.apiUrl}/me/notifications/${id}/mark-read`, {})
            .pipe(catchError((error: Error) => throwError(() => new Error(error.message))));
    }
}
